var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("span", { domProps: { innerHTML: _vm._s(_vm.promoLabel) } }),
    _vm._v(" "),
    _vm.promoEndDate
      ? _c("span", [_vm._v("jusqu’au " + _vm._s(_vm.promoEndDate))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }